export const postalCodeMask = (e: any) => {
  e.currentTarget.maxLength = 9;
  let value = e.currentTarget.value;
  value = value.replace(/^(\d{5})(\d)/, '$1-$2');
  e.currentTarget.value = value;
  return e;
};

export const removeSpecialCharacter = (value: string) => {
  return value.replace(/\D/g, '');
};
